<template>
  <div>
    <p><span v-if="+drug.pack_set > 1" class="badge badge-dark">комплект ({{ +drug.pack_set }} зав.уп.)</span></p>
    <p v-if="+drug.pack_set > 1">Комплект <span class="actual_drug_price">{{
        actualPrice * +drug.pack_set
      }}</span></p>
    <div class="flex flex_gap_5">
      <span v-bind:class="{'fs-12': +drug.pack_set > 1}">Стоимость <span class="actual_drug_price">{{
          actualPrice
        }}</span></span>
      <span v-if="discount" class="badge badge-danger">Скидка</span>
      <template v-if="showCoolCondition">
        <DiscountInfoBlock :drug="drug"/>
      </template>
    </div>
    <div v-if="priceDisabled">
      <span class="badge badge-warning">не активен на сайте!</span>
    </div>
    <p v-if="$AllDivisions[divId]?.settings?.currency_id">
      <strong>{{
          $AllCurrencies[$AllDivisions[divId]?.settings?.currency_id].currency
        }}</strong>
      <span class="actual_drug_price">{{ drug.currency_price }}</span> <span v-if="discount" class="badge badge-danger">Скидка</span>
    </p>
    <p class="badge badge-info" v-if="drug.lgot_price">Льготная доставка</p>
    <button v-if="priceForActualization" @click="updatePriceToActual" class="btn btn-outline-warning btn-xs">
      Актуализировать цену
    </button>
  </div>
</template>

<script>

import DiscountInfoBlock from "@/components/drugs/prices/DiscountInfoBlock.vue";

export default {
  components: {DiscountInfoBlock},
  props: ['drug', 'divId', 'priceDisabled', 'actualPrice', 'priceForActualization', 'discount', 'updatePriceToActual', 'showCoolCondition'],
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  watch: {
    'actualPrice': {
      handler: function (val, oldVal) {
        // console.log(val, oldVal, this.drug);
        // if (oldVal === 0) return;
        this.updateCurrencyPrice(oldVal);
      },
    },
  },
  methods: {
    updateCurrencyPrice(oldVal) {
      if (this.$AllDivisions[this.divId]?.settings?.currency_id) {
        if (oldVal === 0 && this.drug.currency_price) return;
        this.drug.currency_price = Math.round(this.actualPrice * (this.$AllCurrencies[this.$AllDivisions[this.divId]?.settings?.cross_currency_id]?.rate ?? 1) / 50) * 50
      } else {
        this.drug.currency_price = null;
      }
    }
  }
}

</script>

<style scoped>
.actual_drug_price {
  background-color: #4fc47f;
  color: white;
  padding: 2px 5px;
  font-weight: bold;
}

p {
  margin-bottom: 0;
}
</style>
